var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 512 512",
  preserveAspectRatio: "xMidYMid meet"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1a7cec",
  d: "M389.279 0H122.721C54.944 0 0 55.05 0 122.956v266.088C0 456.951 54.944 512 122.721 512h266.558C457.056 512 512 456.951 512 389.044V122.956C512 55.049 457.056 0 389.279 0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  d: "M237.554 369.222c9.187 0 16.669 7.468 16.669 16.672v34.531a16.721 16.721 0 0 1-4.892 11.82 16.66 16.66 0 0 1-11.805 4.881h-32.067a16.65 16.65 0 0 1-11.787-4.892 16.72 16.72 0 0 1-4.882-11.809v-34.531c0-9.204 7.482-16.672 16.698-16.672z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#b)",
  d: "M327.89 279.056c9.216 0 16.698 7.467 16.698 16.672v124.693a16.73 16.73 0 0 1-4.892 11.819 16.66 16.66 0 0 1-11.806 4.882h-32.067c-4.421 0-8.66-1.76-11.786-4.892a16.72 16.72 0 0 1-4.883-11.809V295.728c0-9.205 7.454-16.672 16.669-16.672z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#c)",
  d: "M418.226 188.604c9.216 0 16.669 7.468 16.669 16.672v215.145c0 4.429-1.756 8.677-4.882 11.809a16.65 16.65 0 0 1-11.787 4.892h-32.067a16.6 16.6 0 0 1-6.387-1.263 16.68 16.68 0 0 1-9.039-9.04 16.7 16.7 0 0 1-1.271-6.398V205.276c0-9.204 7.482-16.672 16.697-16.672z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M384.34 74.882c27.329 0 49.833 20.753 52.664 47.353v15.572a27.517 27.517 0 0 1-8.058 19.464 27.42 27.42 0 0 1-19.444 8.034h-35.389a27.4 27.4 0 0 0-10.52 2.076 27.45 27.45 0 0 0-14.888 14.885 27.5 27.5 0 0 0-2.094 10.536v35.399c0 3.614-.711 7.192-2.092 10.53a27.5 27.5 0 0 1-5.957 8.924 27.43 27.43 0 0 1-19.425 8.044h-35.533a27.4 27.4 0 0 0-19.425 8.043 27.5 27.5 0 0 0-5.957 8.924 27.5 27.5 0 0 0-2.092 10.53v35.399c0 3.616-.712 7.196-2.094 10.536a27.5 27.5 0 0 1-5.965 8.928 27.396 27.396 0 0 1-19.443 8.033h-35.476a27.42 27.42 0 0 0-19.425 8.044 27.5 27.5 0 0 0-5.956 8.924 27.5 27.5 0 0 0-2.092 10.53v36.007a27.54 27.54 0 0 1-8.059 19.464 27.405 27.405 0 0 1-19.444 8.033h-10.111a52.87 52.87 0 0 1-37.421-15.5 53.08 53.08 0 0 1-15.532-37.469V127.879c0-29.234 23.689-52.968 52.953-52.968h256.246z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 336.586,
  x2: 279.253,
  y1: 437.126,
  y2: 290.336,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#458ff5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6fa2ff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: 336.586,
  x2: 279.253,
  y1: 437.122,
  y2: 290.332,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#458ff5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6fa2ff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  x1: 336.586,
  x2: 279.253,
  y1: 437.122,
  y2: 290.332,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#458ff5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6fa2ff"
})))));
export default SvgIcon;